import { combineReducers } from 'redux';

function turntableReducer(state = {}, action) {
  switch (action.type) {
    case 'LOAD_TURNTABLE_COMPLETION': {
      const { tid, error, data } = action;

      if (error) {
        return state;
      }

      return {
        ...state,
        [tid]: data,
      };
    }

    case 'LOTTERY_TURNTABLE': {
      const { tid } = action;

      return {
        ...state,
        [tid]: {
          ...state[tid],
          lotteryStatus: 1,
          selected: null,
        },
      };
    }

    case 'LOTTERY_TURNTABLE_COMPLETION': {
      const { error, data, tid } = action;

      if (error) {
        return {
          ...state,
          [tid]: {
            ...state[tid],
            lotteryStatus: 0,
          },
        };
      }

      return {
        ...state,
        [tid]: {
          ...state[tid],
          lotteryStatus: 2,
          selected: data.awardId,
          selectedAwardUser: {
            ...data.awardUser,
            type: data.type,
          },
          lotteryNum: data.lotteryNum || 0
        },
      };
    }

    default:
      return state;
  }
}

function winnersReducer(state = {}, action) {
  switch (action.type) {
    case 'LOAD_TURNTABLE_WINNERS_COMPLETION': {
      const { tid, error, data } = action;

      if (error) {
        return state;
      }

      return {
        ...state,
        [tid]: data,
      };
    }

    case 'INSERT_TURNTABLE_AWRADUSER': {
      const { tid, awardUser } = action;

      let data = { ...state[tid] };

      if (awardUser) {
        data.listData = [awardUser].concat(data.listData);
        data.count += 1;
      }

      return {
        ...state,
        [tid]: data,
      };
    }

    default:
      return state;
  }
}

function countStatReducer(state = {}, action) {
  switch(action.type) {
    case 'LOAD_TURNTABLE_COUNT_COMPLETION': {
      const { tid, error, data } = action;

      if (error) {
        return state;
      }

      return {
        ...state,
        [tid]: data,
      };
    }
    default:
      return state;
  }
}
export default combineReducers({
  turntables: turntableReducer,
  winners: winnersReducer,
  countStat: countStatReducer,
});
